import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/DepartmentOverview/page.tsx");
